export const EnumCountries = {
    ESP: process?.env?.REACT_APP_ENVELOP_ACTIVE_3CODE_COUNTRY == "true" ? "ESP" : "ES",
    AND: process?.env?.REACT_APP_ENVELOP_ACTIVE_3CODE_COUNTRY == "true" ? "AND" : "AD",
};